import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import validateFormAddPage from "../../../validtions/forms/page/add";
import validationsFormsFinanceCharge from "../../../validtions/forms/finance/charge";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import helpersNumbers from "../../../helpers/numbers";

function EditPage() {
  const params = useParams();
  const history = useHistory();
  const [message, setMessage] = useState();
  const [active, setActive] = useState(false);
  const [imageFile, setImageFile] = useState();
  const [webSitePublisherData, setWebSitePublisherData] = useState({});
  const [pageData, setPageData] = useState();
  const [maxPriorityPageOnSitePublisher, setMaxPriorityPageOnSitePublisher] =
    useState();
  const pageID = params.id;
  let messageTag;

  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  useEffect(() => {
    getPageData(pageID);
  }, []);

  useEffect(() => {
    if (!pageData) {
      return;
    }

    setActive(pageData.pag_active);
  }, [pageData]);

  useEffect(() => {
    if (!pageData) {
      return;
    }
    getMaxPriorityPageOnSitePublisher();
  }, [pageData]);

  const getMaxPriorityPageOnSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const maxPriorityPageOnSitePublisher = await sendRequestGetWebSitePublisher(
      pageData.pag_web_site_publisher_id
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!maxPriorityPageOnSitePublisher) {
      return;
    }
    setMaxPriorityPageOnSitePublisher(maxPriorityPageOnSitePublisher);
  };

  const sendRequestGetWebSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/page/manage/web-site-publisher/${sitePublisherID}/get-max-priority/`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return resultRequest.data.data;
  };

  const getPageData = async (pageID) => {
    const resultSendRequestGetPageData = await sendRequestGetPageData(pageID);
    if (!resultSendRequestGetPageData) {
      return;
    }
    setPageData(resultSendRequestGetPageData);
    await getWebSitePublisherData(
      resultSendRequestGetPageData.pag_web_site_publisher_id
    );
  };

  const sendRequestGetPageData = async (pageID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/manage/" + pageID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const getWebSitePublisherData = async (webSitePublisherID) => {
    setWebSitePublisherData(
      await sendRequestGetWebSitePublisherData(webSitePublisherID)
    );
  };

  const sendRequestGetWebSitePublisherData = async (sitePublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    let dataForm = getDataForm();
    if (validateFormAddPage(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormAddPage(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }
    dataForm.web_site_publisher_id = webSitePublisherData.id;
    dataForm = generateFormData(dataForm);
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const resultSendRequestEditPage = await sendRequestEditPage(dataForm);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!resultSendRequestEditPage) {
      return;
    }

    history.push(`/manage/page/all/${webSitePublisherData.id}`);
  };

  const sendRequestEditPage = async (dataForm) => {
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/page/manage/" + pageID,
        dataForm,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return true;
  };

  const generateFormData = (dataForm) => {
    const formData = new FormData();
    formData.append("file", imageFile);
    formData.append("title", dataForm.title);
    formData.append("pattern", dataForm.pattern);
    formData.append("link", dataForm.link);
    formData.append("active", dataForm.active);
    formData.append("web_site_publisher_id", dataForm.web_site_publisher_id);
    formData.append("priority", dataForm.priority);
    return formData;
  };

  const getDataForm = () => {
    return {
      title: document.querySelector("#title").value,
      priority: document.querySelector("#priority").value,
      pattern: decodeURI(document.querySelector("#pattern").value),
      link: decodeURI(document.querySelector("#link").value),
      active: active,
    };
  };

  const scrollForSeeMessage = () => {
    const element = document.getElementById("edit-page");
    element.scrollIntoView();
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span>ویرایش صفحه به سایت</span>
                  <span className="pr-2">
                    <a
                      target="_blank"
                      className="text-white"
                      href={webSitePublisherData?.url}
                    >
                      {webSitePublisherData?.url?.replace("http://", "")}
                    </a>
                  </span>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body" id="edit-page">
              {messageTag}
              <div className="text-left">
                {webSitePublisherData !== null ? (
                  <div className="text-white">
                    <Link to={`/manage/page/all/${webSitePublisherData.id}`}>
                      <div className="btn btn-primary">
                        <span>
                          <span className="text-white">بازگشت</span>
                        </span>
                        <span className="pr-2">
                          <i
                            className="fas fa-arrow-left"
                            aria-hidden="true"
                          ></i>
                        </span>
                      </div>
                    </Link>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <form onSubmit={sendForm}>
                <div className="form-group">
                  <label>عنوان</label>
                  <input
                    dir="rtl"
                    type="text"
                    id="title"
                    className="form-control"
                    defaultValue={pageData?.pag_title}
                  />
                </div>

                <div class="alert alert-info">
                  <p>
                    برای ایجاد آدرس , صفحات ثابت بصورت زیر , آدرس را درج کنید
                  </p>
                  <p>
                    <span className="pl-2">عنوان : </span>
                    <span className="pl-2">تماس با ما</span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">الگو آدرس : </span>
                    <span className="pl-2" dir="ltr">
                      /contact-us
                    </span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">لینک : </span>
                    <span dir="ltr" className="pl-2">
                      https://monirlock.ir/contact-us
                    </span>
                  </p>
                  <p>
                    <span className="pl-2">عنوان : </span>
                    <span className="pl-2">درباره ما</span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">الگو آدرس : </span>
                    <span className="pl-2" dir="ltr">
                      /about-us
                    </span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">لینک : </span>
                    <span dir="ltr" className="pl-2">
                      https://monirlock.ir/about-us
                    </span>
                  </p>
                  <hr />
                  <p>
                    برای ایجاد آدرس , صفحات متغیر بصورت زیر , آدرس را درج کنید
                  </p>
                  <p>
                    <span className="pl-2">عنوان : </span>
                    <span className="pl-2">صفحات محصولات</span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">الگو آدرس : </span>
                    <span className="pl-2" dir="ltr">
                      /product/@s
                    </span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">لینک : </span>
                    <span dir="ltr" className="pl-2">
                      http://monirlock.ir/product/10941
                    </span>
                  </p>
                  <p>
                    <span className="pl-2">عنوان : </span>
                    <span className="pl-2">صفحات مطالب</span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">الگو آدرس : </span>
                    <span className="pl-2" dir="ltr">
                      /blog/@s
                    </span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">لینک : </span>
                    <span dir="ltr" className="pl-2">
                      {decodeURI(
                        "https://monirlock.ir/blog/%d8%a7%d9%86%d9%88%d8%a7%d8%b9-%da%a9%d9%84%db%8c%d8%af-%d9%87%d8%a7%db%8c-%d9%85%d9%86%db%8c%d8%b1-%d8%b5%d9%86%d8%b9%d8%aa"
                      )}
                    </span>
                  </p>
                  <hr />
                  <p>برای ایجاد آدرس , صفحه اصلی , آدرس زیر را درج کنید</p>
                  <p>
                    <span className="pl-2">عنوان : </span>
                    <span className="pl-2">صفحه اصلی</span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">الگو آدرس : </span>
                    <span className="pl-2" dir="ltr">
                      /
                    </span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">لینک : </span>
                    <span dir="ltr" className="pl-2">
                      http://monirlock.ir
                    </span>
                  </p>
                  <p>
                    برای ایجاد آدرس , صفحه متغییر بدون پیش وند , آدرس زیر را درج
                    کنید
                  </p>
                  <p>
                    <span className="pl-2">عنوان : </span>
                    <span className="pl-2">صفحات مطالب</span>
                    <span className="pl-2"> - </span>
                    <span className="pl-2">الگو آدرس : </span>
                    <span className="pl-2" dir="ltr">
                      /@s
                    </span>
                    <span className="pl-2">-</span>
                    <span className="pl-2">لینک : </span>
                    <span dir="ltr" className="pl-2">
                      {decodeURI(
                        "https://monirlock.ir/%d8%a7%d9%86%d9%88%d8%a7%d8%b9-%da%a9%d9%84%db%8c%d8%af-%d9%87%d8%a7%db%8c-%d9%85%d9%86%db%8c%d8%b1-%d8%b5%d9%86%d8%b9%d8%aa"
                      )}
                    </span>
                  </p>
                  <hr />
                  <p>برای آپلود عکس صفحه فقط از فرمت webp استفاده کنید </p>
                </div>
                <div className="form-group">
                  <label>الگو آدرس</label>
                  <input
                    dir="ltr"
                    type="text"
                    id="pattern"
                    defaultValue={pageData?.pag_pattern_url}
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>لینک صفحه </label>
                  <input
                    dir="ltr"
                    type="text"
                    id="link"
                    defaultValue={pageData?.pag_link}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    اولویت برای گروه نمایش دهنده خودکار
                    {maxPriorityPageOnSitePublisher && (
                      <span>
                        ( بالاترین اولویت سایت =
                        {helpersNumbers.toPersianNum(
                          maxPriorityPageOnSitePublisher
                        )}
                        )
                      </span>
                    )}
                  </label>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    id="priority"
                    defaultValue={pageData?.pag_priority}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active"
                        checked={active}
                        onChange={() => {
                          setActive(!active);
                        }}
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <div>
                    <label>عکس صفحه</label>
                  </div>
                  <div>
                    <input
                      type="file"
                      id="image-file"
                      accept="image/webp"
                      onChange={(e) => {
                        e.preventDefault();
                        setImageFile(e.target.files[0]);
                      }}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <div className="border border-success">
                    <a
                      target="_blank"
                      href={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.pag_img_name}`}
                    >
                      <img
                        className="img-fluid"
                        src={`${process.env.REACT_APP_DOMAIN_API}/${process.env.REACT_APP_URL_PAGE_FILES}/${pageData?.pag_img_name}`}
                      />
                    </a>
                  </div>
                </div>

                <div className="form-group">
                  <button className="btn btn-primary">ویرایش کردن</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditPage;
